import { Text } from '@wartek-id/text-v1'
import { Dialog, DialogOverlay, DialogContent } from '@wartek-id/dialog-v1'
import type { DialogProps } from '@wartek-id/dialog-v1'
import { Button } from '@wartek-id/button-v1'

import { assetUrl } from 'utils/url'

type DialogBlockPeriodNonAsnProps = Omit<DialogProps, 'size' | 'children'> & {
  isKS?: boolean
}

export default function DialogBlockPeriodNonAsn({
  isKS = false,
  ...dialogProps
}: DialogBlockPeriodNonAsnProps) {
  return (
    <Dialog {...dialogProps} size="sm">
      <DialogOverlay />
      <DialogContent aria-labelledby="card-block-period-dialog-title">
        <div className="p-6">
          <img
            src={assetUrl('/illustrations/img-empty-document-2.png')}
            alt=""
            width={84}
            height={84}
            className="mb-4"
          />

          <div className="mb-6">
            <Text variant="display-sm" as="h2" className="mb-2">
              {isKS
                ? 'Data tidak dapat diakses lagi'
                : 'Data periode sebelum Anda memperoleh Penugasan JF Guru tidak dapat diakses lagi'}
            </Text>

            <Text variant="body-lg" color="subdued">
              {isKS
                ? 'Guru ini baru memperoleh Penugasan JF Guru. Sehingga, data ketika Guru belum memperoleh Penugasan JF Guru tidak dapat diakses lagi.'
                : 'Anda dapat diskusi dengan atasan untuk selengkapnya.'}
            </Text>
          </div>

          <Button
            color="blue"
            size="lg"
            type="button"
            onClick={() => dialogProps.onClose?.()}
          >
            Saya mengerti
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
